import React from 'react';

import { ReactComponent as Logo } from './images/logo.svg';

const Header = () => {
  return (
    <div style={{backgroundColor: 'black',
                 display: 'flex',
                 flexDirection: 'row',
                 justifyContent: 'space-between',
                 alignItems: 'center',
                 padding: '0px 50px',
                 borderBottom: '1px solid gray',
                }}>
      <Logo className='image'
            style={{width: '150px',
                    height: 'auto',
                    fill: 'white',
                    color: 'white',
                   }} />
      <h2 style={{color: 'white'}}>
        Admin Dashboard
      </h2>
    </div>
  );
}

export default Header;
